// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/common/currency_codes.proto
/* eslint-disable */
import * as _m0 from "protobufjs/minimal.js";
// For Node.js to access named exports from CommonJS
const __m0 = 'default' in _m0 ? _m0.default : _m0;
export const protobufPackage = "squareup.common";
/** These rounding modes match with NSRoundingMode in NSDecimal.h */
export var RoundingMode;
(function (RoundingMode) {
    /** PLAIN - Round up on a tie. */
    RoundingMode[RoundingMode["PLAIN"] = 0] = "PLAIN";
    /** DOWN - Always round down == truncate. */
    RoundingMode[RoundingMode["DOWN"] = 1] = "DOWN";
    /** UP - Always up. */
    RoundingMode[RoundingMode["UP"] = 2] = "UP";
    /** BANKERS - On a tie round so the last digit is even. */
    RoundingMode[RoundingMode["BANKERS"] = 3] = "BANKERS";
    /** DOWN_ON_HALF - Round down on a tie. */
    RoundingMode[RoundingMode["DOWN_ON_HALF"] = 4] = "DOWN_ON_HALF";
})(RoundingMode || (RoundingMode = {}));
/**
 * ISO-4217 Currency Codes
 * http://www.currency-iso.org/dl_iso_table_a1.xml
 * Names are the alpha-3 code, ordinals are the numeric code.
 */
export var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode[CurrencyCode["AED"] = 784] = "AED";
    CurrencyCode[CurrencyCode["AFN"] = 971] = "AFN";
    CurrencyCode[CurrencyCode["ALL"] = 8] = "ALL";
    CurrencyCode[CurrencyCode["AMD"] = 51] = "AMD";
    CurrencyCode[CurrencyCode["ANG"] = 532] = "ANG";
    CurrencyCode[CurrencyCode["AOA"] = 973] = "AOA";
    CurrencyCode[CurrencyCode["ARS"] = 32] = "ARS";
    CurrencyCode[CurrencyCode["AUD"] = 36] = "AUD";
    CurrencyCode[CurrencyCode["AWG"] = 533] = "AWG";
    CurrencyCode[CurrencyCode["AZN"] = 944] = "AZN";
    CurrencyCode[CurrencyCode["BAM"] = 977] = "BAM";
    CurrencyCode[CurrencyCode["BBD"] = 52] = "BBD";
    CurrencyCode[CurrencyCode["BDT"] = 50] = "BDT";
    CurrencyCode[CurrencyCode["BGN"] = 975] = "BGN";
    CurrencyCode[CurrencyCode["BHD"] = 48] = "BHD";
    CurrencyCode[CurrencyCode["BIF"] = 108] = "BIF";
    CurrencyCode[CurrencyCode["BMD"] = 60] = "BMD";
    CurrencyCode[CurrencyCode["BND"] = 96] = "BND";
    CurrencyCode[CurrencyCode["BOB"] = 68] = "BOB";
    CurrencyCode[CurrencyCode["BOV"] = 984] = "BOV";
    CurrencyCode[CurrencyCode["BRL"] = 986] = "BRL";
    CurrencyCode[CurrencyCode["BSD"] = 44] = "BSD";
    CurrencyCode[CurrencyCode["BTN"] = 64] = "BTN";
    CurrencyCode[CurrencyCode["BWP"] = 72] = "BWP";
    CurrencyCode[CurrencyCode["BYR"] = 974] = "BYR";
    CurrencyCode[CurrencyCode["BZD"] = 84] = "BZD";
    CurrencyCode[CurrencyCode["CAD"] = 124] = "CAD";
    CurrencyCode[CurrencyCode["CDF"] = 976] = "CDF";
    CurrencyCode[CurrencyCode["CHE"] = 947] = "CHE";
    CurrencyCode[CurrencyCode["CHF"] = 756] = "CHF";
    CurrencyCode[CurrencyCode["CHW"] = 948] = "CHW";
    CurrencyCode[CurrencyCode["CLF"] = 990] = "CLF";
    CurrencyCode[CurrencyCode["CLP"] = 152] = "CLP";
    CurrencyCode[CurrencyCode["CNY"] = 156] = "CNY";
    CurrencyCode[CurrencyCode["COP"] = 170] = "COP";
    CurrencyCode[CurrencyCode["COU"] = 970] = "COU";
    CurrencyCode[CurrencyCode["CRC"] = 188] = "CRC";
    CurrencyCode[CurrencyCode["CUC"] = 931] = "CUC";
    CurrencyCode[CurrencyCode["CUP"] = 192] = "CUP";
    CurrencyCode[CurrencyCode["CVE"] = 132] = "CVE";
    CurrencyCode[CurrencyCode["CZK"] = 203] = "CZK";
    CurrencyCode[CurrencyCode["DJF"] = 262] = "DJF";
    CurrencyCode[CurrencyCode["DKK"] = 208] = "DKK";
    CurrencyCode[CurrencyCode["DOP"] = 214] = "DOP";
    CurrencyCode[CurrencyCode["DZD"] = 12] = "DZD";
    CurrencyCode[CurrencyCode["EGP"] = 818] = "EGP";
    CurrencyCode[CurrencyCode["ERN"] = 232] = "ERN";
    CurrencyCode[CurrencyCode["ETB"] = 230] = "ETB";
    CurrencyCode[CurrencyCode["EUR"] = 978] = "EUR";
    CurrencyCode[CurrencyCode["FJD"] = 242] = "FJD";
    CurrencyCode[CurrencyCode["FKP"] = 238] = "FKP";
    CurrencyCode[CurrencyCode["GBP"] = 826] = "GBP";
    CurrencyCode[CurrencyCode["GEL"] = 981] = "GEL";
    CurrencyCode[CurrencyCode["GHS"] = 936] = "GHS";
    CurrencyCode[CurrencyCode["GIP"] = 292] = "GIP";
    CurrencyCode[CurrencyCode["GMD"] = 270] = "GMD";
    CurrencyCode[CurrencyCode["GNF"] = 324] = "GNF";
    CurrencyCode[CurrencyCode["GTQ"] = 320] = "GTQ";
    CurrencyCode[CurrencyCode["GYD"] = 328] = "GYD";
    CurrencyCode[CurrencyCode["HKD"] = 344] = "HKD";
    CurrencyCode[CurrencyCode["HNL"] = 340] = "HNL";
    CurrencyCode[CurrencyCode["HRK"] = 191] = "HRK";
    CurrencyCode[CurrencyCode["HTG"] = 332] = "HTG";
    CurrencyCode[CurrencyCode["HUF"] = 348] = "HUF";
    CurrencyCode[CurrencyCode["IDR"] = 360] = "IDR";
    CurrencyCode[CurrencyCode["ILS"] = 376] = "ILS";
    CurrencyCode[CurrencyCode["INR"] = 356] = "INR";
    CurrencyCode[CurrencyCode["IQD"] = 368] = "IQD";
    CurrencyCode[CurrencyCode["IRR"] = 364] = "IRR";
    CurrencyCode[CurrencyCode["ISK"] = 352] = "ISK";
    CurrencyCode[CurrencyCode["JMD"] = 388] = "JMD";
    CurrencyCode[CurrencyCode["JOD"] = 400] = "JOD";
    CurrencyCode[CurrencyCode["JPY"] = 392] = "JPY";
    CurrencyCode[CurrencyCode["KES"] = 404] = "KES";
    CurrencyCode[CurrencyCode["KGS"] = 417] = "KGS";
    CurrencyCode[CurrencyCode["KHR"] = 116] = "KHR";
    CurrencyCode[CurrencyCode["KMF"] = 174] = "KMF";
    CurrencyCode[CurrencyCode["KPW"] = 408] = "KPW";
    CurrencyCode[CurrencyCode["KRW"] = 410] = "KRW";
    CurrencyCode[CurrencyCode["KWD"] = 414] = "KWD";
    CurrencyCode[CurrencyCode["KYD"] = 136] = "KYD";
    CurrencyCode[CurrencyCode["KZT"] = 398] = "KZT";
    CurrencyCode[CurrencyCode["LAK"] = 418] = "LAK";
    CurrencyCode[CurrencyCode["LBP"] = 422] = "LBP";
    CurrencyCode[CurrencyCode["LKR"] = 144] = "LKR";
    CurrencyCode[CurrencyCode["LRD"] = 430] = "LRD";
    CurrencyCode[CurrencyCode["LSL"] = 426] = "LSL";
    CurrencyCode[CurrencyCode["LTL"] = 440] = "LTL";
    CurrencyCode[CurrencyCode["LVL"] = 428] = "LVL";
    CurrencyCode[CurrencyCode["LYD"] = 434] = "LYD";
    CurrencyCode[CurrencyCode["MAD"] = 504] = "MAD";
    CurrencyCode[CurrencyCode["MDL"] = 498] = "MDL";
    CurrencyCode[CurrencyCode["MGA"] = 969] = "MGA";
    CurrencyCode[CurrencyCode["MKD"] = 807] = "MKD";
    CurrencyCode[CurrencyCode["MMK"] = 104] = "MMK";
    CurrencyCode[CurrencyCode["MNT"] = 496] = "MNT";
    CurrencyCode[CurrencyCode["MOP"] = 446] = "MOP";
    CurrencyCode[CurrencyCode["MRO"] = 478] = "MRO";
    CurrencyCode[CurrencyCode["MUR"] = 480] = "MUR";
    CurrencyCode[CurrencyCode["MVR"] = 462] = "MVR";
    CurrencyCode[CurrencyCode["MWK"] = 454] = "MWK";
    CurrencyCode[CurrencyCode["MXN"] = 484] = "MXN";
    CurrencyCode[CurrencyCode["MXV"] = 979] = "MXV";
    CurrencyCode[CurrencyCode["MYR"] = 458] = "MYR";
    CurrencyCode[CurrencyCode["MZN"] = 943] = "MZN";
    CurrencyCode[CurrencyCode["NAD"] = 516] = "NAD";
    CurrencyCode[CurrencyCode["NGN"] = 566] = "NGN";
    CurrencyCode[CurrencyCode["NIO"] = 558] = "NIO";
    CurrencyCode[CurrencyCode["NOK"] = 578] = "NOK";
    CurrencyCode[CurrencyCode["NPR"] = 524] = "NPR";
    CurrencyCode[CurrencyCode["NZD"] = 554] = "NZD";
    CurrencyCode[CurrencyCode["OMR"] = 512] = "OMR";
    CurrencyCode[CurrencyCode["PAB"] = 590] = "PAB";
    CurrencyCode[CurrencyCode["PEN"] = 604] = "PEN";
    CurrencyCode[CurrencyCode["PGK"] = 598] = "PGK";
    CurrencyCode[CurrencyCode["PHP"] = 608] = "PHP";
    CurrencyCode[CurrencyCode["PKR"] = 586] = "PKR";
    CurrencyCode[CurrencyCode["PLN"] = 985] = "PLN";
    CurrencyCode[CurrencyCode["PYG"] = 600] = "PYG";
    CurrencyCode[CurrencyCode["QAR"] = 634] = "QAR";
    CurrencyCode[CurrencyCode["RON"] = 946] = "RON";
    CurrencyCode[CurrencyCode["RSD"] = 941] = "RSD";
    CurrencyCode[CurrencyCode["RUB"] = 643] = "RUB";
    CurrencyCode[CurrencyCode["RWF"] = 646] = "RWF";
    CurrencyCode[CurrencyCode["SAR"] = 682] = "SAR";
    CurrencyCode[CurrencyCode["SBD"] = 90] = "SBD";
    CurrencyCode[CurrencyCode["SCR"] = 690] = "SCR";
    CurrencyCode[CurrencyCode["SDG"] = 938] = "SDG";
    CurrencyCode[CurrencyCode["SEK"] = 752] = "SEK";
    CurrencyCode[CurrencyCode["SGD"] = 702] = "SGD";
    CurrencyCode[CurrencyCode["SHP"] = 654] = "SHP";
    CurrencyCode[CurrencyCode["SLL"] = 694] = "SLL";
    CurrencyCode[CurrencyCode["SOS"] = 706] = "SOS";
    CurrencyCode[CurrencyCode["SRD"] = 968] = "SRD";
    CurrencyCode[CurrencyCode["SSP"] = 728] = "SSP";
    CurrencyCode[CurrencyCode["STD"] = 678] = "STD";
    CurrencyCode[CurrencyCode["SVC"] = 222] = "SVC";
    CurrencyCode[CurrencyCode["SYP"] = 760] = "SYP";
    CurrencyCode[CurrencyCode["SZL"] = 748] = "SZL";
    CurrencyCode[CurrencyCode["THB"] = 764] = "THB";
    CurrencyCode[CurrencyCode["TJS"] = 972] = "TJS";
    CurrencyCode[CurrencyCode["TMT"] = 934] = "TMT";
    CurrencyCode[CurrencyCode["TND"] = 788] = "TND";
    CurrencyCode[CurrencyCode["TOP"] = 776] = "TOP";
    CurrencyCode[CurrencyCode["TRY"] = 949] = "TRY";
    CurrencyCode[CurrencyCode["TTD"] = 780] = "TTD";
    CurrencyCode[CurrencyCode["TWD"] = 901] = "TWD";
    CurrencyCode[CurrencyCode["TZS"] = 834] = "TZS";
    CurrencyCode[CurrencyCode["UAH"] = 980] = "UAH";
    CurrencyCode[CurrencyCode["UGX"] = 800] = "UGX";
    CurrencyCode[CurrencyCode["USD"] = 840] = "USD";
    CurrencyCode[CurrencyCode["USN"] = 997] = "USN";
    CurrencyCode[CurrencyCode["USS"] = 998] = "USS";
    CurrencyCode[CurrencyCode["UYI"] = 940] = "UYI";
    CurrencyCode[CurrencyCode["UYU"] = 858] = "UYU";
    CurrencyCode[CurrencyCode["UZS"] = 860] = "UZS";
    CurrencyCode[CurrencyCode["VEF"] = 937] = "VEF";
    CurrencyCode[CurrencyCode["VND"] = 704] = "VND";
    CurrencyCode[CurrencyCode["VUV"] = 548] = "VUV";
    CurrencyCode[CurrencyCode["WST"] = 882] = "WST";
    CurrencyCode[CurrencyCode["XAF"] = 950] = "XAF";
    CurrencyCode[CurrencyCode["XAG"] = 961] = "XAG";
    CurrencyCode[CurrencyCode["XAU"] = 959] = "XAU";
    CurrencyCode[CurrencyCode["XBA"] = 955] = "XBA";
    CurrencyCode[CurrencyCode["XBB"] = 956] = "XBB";
    CurrencyCode[CurrencyCode["XBC"] = 957] = "XBC";
    CurrencyCode[CurrencyCode["XBD"] = 958] = "XBD";
    CurrencyCode[CurrencyCode["XCD"] = 951] = "XCD";
    CurrencyCode[CurrencyCode["XDR"] = 960] = "XDR";
    CurrencyCode[CurrencyCode["XOF"] = 952] = "XOF";
    CurrencyCode[CurrencyCode["XPD"] = 964] = "XPD";
    CurrencyCode[CurrencyCode["XPF"] = 953] = "XPF";
    CurrencyCode[CurrencyCode["XPT"] = 962] = "XPT";
    CurrencyCode[CurrencyCode["XTS"] = 963] = "XTS";
    CurrencyCode[CurrencyCode["XXX"] = 999] = "XXX";
    CurrencyCode[CurrencyCode["YER"] = 886] = "YER";
    CurrencyCode[CurrencyCode["ZAR"] = 710] = "ZAR";
    CurrencyCode[CurrencyCode["ZMK"] = 894] = "ZMK";
    CurrencyCode[CurrencyCode["ZMW"] = 967] = "ZMW";
    /** BTC - Currency codes not currently in ISO-4217: */
    CurrencyCode[CurrencyCode["BTC"] = 1001] = "BTC";
    CurrencyCode[CurrencyCode["XUS"] = 1002] = "XUS";
    /**
     * SLE - This is added to the end of the list because Cash Lending services are encoding
     * the ordinal position of the enum instead of the enum codes
     */
    CurrencyCode[CurrencyCode["SLE"] = 925] = "SLE";
})(CurrencyCode || (CurrencyCode = {}));
function createBaseDenominations() {
    return { $type: "squareup.common.Denominations", banknoteCents: [], coinCents: [] };
}
export const Denominations = {
    $type: "squareup.common.Denominations",
    encode(message, writer = __m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.banknoteCents) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(18).fork();
        for (const v of message.coinCents) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDenominations();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag === 8) {
                        message.banknoteCents.push(reader.int32());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.banknoteCents.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 2:
                    if (tag === 16) {
                        message.coinCents.push(reader.int32());
                        continue;
                    }
                    if (tag === 18) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.coinCents.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Denominations.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDenominations();
        message.banknoteCents = object.banknoteCents?.map((e) => e) || [];
        message.coinCents = object.coinCents?.map((e) => e) || [];
        return message;
    },
};
